import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../../IModel';
import { Model } from '../../model';
import { EmployeeModel } from 'services/models/employee.model';
import { FileContentModel } from 'services/models/fileContent';
import { WCKOccurrenceModel } from '../workcheck/wck-occurrence.model';
import { EthicsChannelReportModel } from '../ethics-channel/ethics-channel-report.model';
import { ActionPlanStatus } from './enum/ActionPlanStatus.enum';

export class ActionPlanModel extends Model implements IModel<ActionPlanModel> {
  public reportId: string = '';
  public occurrenceId: string = '';
  public source: string = '';
  public typeId: string = '';
  public what: string = '';
  public responsibleId: string = '';
  public description: string = '';
  public forecastDate: string = '';
  public status: string | number = '';
  public resolutionDescription: string = '';
  public resolutionFileName: string = '';
  public resolutionFileKey: string = '';
  public occurrence: WCKOccurrenceModel = null;
  public report: EthicsChannelReportModel = null;
  public responsible: EmployeeModel = null;
  public responsibleName: string = '';
  public fileContent: FileContentModel = null;
  public typeTitle: string = '';

  public get statusOption() {
    return ActionPlanStatus.get(this.status);
  }

  static create(input: any): ActionPlanModel {
    return ObjectMapper.deserialize<ActionPlanModel>(ActionPlanModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
